import React from 'react'
import {
    Button,
    Dialog,
    DialogContent,
    DialogActions,
    TextField,
    IconButton,
    Paper,
    Typography,
    Tooltip
} from '@mui/material/';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

const ModalPDF = (props) => {

  const {
    abrirModal,
    handleClose, 
    exportData, 
    setNombreArchivo
  } = props;

  return (
    <Dialog
        open={abrirModal}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
    >
        <DialogContent>
            <Typography
                variant="h4"
                align='center'
                sx={{
                    marginBottom: '20px',
                    fontWeight: 'bold'
                }}
            >
                Exportar en PDF
            </Typography>
            <Paper 
                component="form"
                style={{color: 'red'}}
                sx={{
                    p: '2px 4px',
                    display: 'flex',
                    alignItems: 'center',
                    width: 400
                }}    
            >
                <TextField 
                    sx={{ flex: 1 }}
                    label="Nombre Archivo" 
                    variant="outlined" 
                    onChange={(e)=>{
                        setNombreArchivo(e.target.value)
                    }}
                />
                <Tooltip title='Descargar PDF'>

                    <IconButton 
                        color='primary' 
                        type='submit' 
                        sx={{p: '10px'}}
                        onClick={exportData}
                        
                        >
                        <FileDownloadIcon fontSize='medium'/>
                    </IconButton>
                </Tooltip>
            </Paper>
        </DialogContent>

        <DialogActions>
            <Button onClick={handleClose}>
                Cerrar
            </Button>
        </DialogActions>
    </Dialog>
  )
}

export default ModalPDF;